export default "__VITE_ASSET__DjEISLiD__"